import { QuerySearchBarProps } from "./QuerySearchBar.types";
import useSearchParam from "ui/common/hooks/useSearchParam";
import { useEffect, useState } from "react";
import { SearchBarRoot } from "./QuerySearchBar.styles";

const QuerySearchBar = (props: QuerySearchBarProps): JSX.Element => {
    const [searchParam, setSearchParam] = useSearchParam("query");
    const [defaultValue, setDefaultValue] = useState<string>();

    useEffect(() => {
        if (!defaultValue && searchParam) {
            setDefaultValue(searchParam);
        }
    }, [searchParam, defaultValue]);

    return <SearchBarRoot showPrefix={false} showSuffix defaultValue={defaultValue} key={defaultValue} onChange={setSearchParam} {...props} />;
};

export default QuerySearchBar;
